import React from 'react';
import './RiskMeter.css';

export default function RiskMeter({ score = 0 }) {
  const clamped = Math.max(0, Math.min(100, score));
  const angle = -90 + (clamped / 100) * 180; // -90 (left) to +90 (right)

  return (
    <div className="meter">
      <svg viewBox="0 0 200 120" className="meter-svg" aria-label={`Risk score ${clamped}`}>
        <defs>
          <linearGradient id="rg" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#e11d48" />
            <stop offset="50%" stopColor="#f59e0b" />
            <stop offset="100%" stopColor="#10b981" />
          </linearGradient>
        </defs>
        <path d="M10,110 A90,90 0 0 1 190,110" fill="none" stroke="url(#rg)" strokeWidth="20" />
        <circle cx="100" cy="110" r="6" fill="#111" />
        <g transform={`rotate(${angle} 100 110)`}>
          <rect x="98" y="18" width="4" height="92" fill="#111" rx="2" />
        </g>
        <text x="100" y="115" textAnchor="middle" fontSize="12" fill="#555">{clamped}</text>
      </svg>
    </div>
  );
}
